
import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { StoreModule, ActionReducerMap } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { ImageModule } from '@ux/components/image/image.module';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { HomeContainer } from '@home/components/home-container/home.container';
import { HomeRoutingModule } from '@home/home-routing.module';
import { HomeModuleState, homeFeatureName } from './store/state/home-module.state';
import { HomeEffect } from '@home/store/effects/home.effects';
import { HomeFacade } from '@home/home.facade';
import { homeRootReducer } from '@home/store/reducers';
import { HomeService } from '@home/services/home.service';
import { SlidersModule } from '@app/modules/shared/sliders/sliders.module';
import { HomeSectionsModule } from '@app/modules/shared/home-sections/home-sections.module';
import { HomePlaceholderComponent } from '@home/components/home-placeholder/home-placeholder.component';
import { HomeSearchDesktopComponent } from '@home/components/home-search-desktop/home-search-desktop.component';
import { SearchBarModule } from '@search-bar/search-bar.module';
import { HotelSearchModule } from '@hotels/hotel-search/hotel-search.module';
import { AutoSearchModule } from '@autos/auto-search/auto-search.module';
import { TermsModule } from '@terms-conditions/terms.module';
import { PrivacyPolicyModule } from '@privacy-policy/privacy-policy.module';
import { GalleryDestinationModule } from '@ux/components/gallery-destination/gallery-destination.module';
import { PackagesSearchBarModule } from '@packages/packages-search-bar/packages-search-bar.module';
import { RightRepentanceModule } from '@right-repentance/right-repentance.module';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { ModalModule } from '@ux/components/modal/modal.module';
import { UserHistoryFacade } from '@user-history/user-history.facade';
import { PdfViewerModule } from '@shared/pdf-viewer/pdf-viewer.module';
import { AbandonedReservationModule } from '@abandoned-reservation/abandoned-reservation.module';
import { ChipModule } from '@ux/components/chip/chip.module';
import { RecentSearchesModule } from '@recent-searches/recent-searches.module';
import { ChipActionDsComponent } from '@design-system/components/molecules/chip-action/chip-action.component';
import { InputSearchDsComponent } from '@design-system/components/molecules/input-search/input-search.component';
import { NoModuleAvailableModule } from '@shared/no-module-available/no-module-available.module';
import { ActivitiesSearchBarModule } from '@activities/activities-search-bar/activities-search-bar.module';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { ButtonIconDsComponent } from '@design-system/components/molecules/button-icon/button-icon.component';
import { FooterModule } from '@app/modules/core/footer/footer.module';

export const FEATURE_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<HomeModuleState>
  >('Feature Reducers');

@NgModule({
  declarations: [
    HomeContainer,
    HomeSearchDesktopComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    TranslocoModule,
    GlobalPipesModule,
    StoreModule.forFeature(homeFeatureName, FEATURE_REDUCER_TOKEN),
    EffectsModule.forFeature([HomeEffect]),
    ImageModule,
    SlidersModule,
    HomeSectionsModule,
    SearchBarModule,
    HotelSearchModule,
    AutoSearchModule,
    TermsModule,
    PrivacyPolicyModule,
    GalleryDestinationModule,
    RightRepentanceModule,
    PackagesSearchBarModule,
    SwipeUpModule,
    ModalModule,
    PdfViewerModule,
    AbandonedReservationModule,
    ChipModule,
    RecentSearchesModule,
    ChipActionDsComponent,
    InputSearchDsComponent,
    NoModuleAvailableModule,
    ActivitiesSearchBarModule,
    TypographyDsComponent,
    ButtonIconDsComponent,
    FooterModule,
    HomePlaceholderComponent,
  ],
  providers: [
    HomeFacade,
    {
      provide: FEATURE_REDUCER_TOKEN,
      useValue: homeRootReducer
    },
    HomeService,
    UserHistoryFacade
  ]
})
export class HomeModule { }
